import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { LogOut, Map, BarChart3 } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

/** Sales mode shell — dark, thumb-friendly, built for a phone on a doorstep. */
export default function SalesLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-gray-950 text-white flex flex-col">
      <header className="px-4 py-3 flex items-center justify-between sticky top-0 z-40 bg-gray-950/90 backdrop-blur border-b border-white/10">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-brand-400 font-bold">Sales mode</div>
          <div className="font-black text-lg leading-tight">Keep Austin Mowed</div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs text-gray-500">{user?.name}</span>
          <button onClick={logout} className="p-2 rounded-lg text-gray-500 hover:text-white hover:bg-white/10" title="Sign out"><LogOut className="h-4 w-4" /></button>
        </div>
      </header>
      <main className="flex-1 w-full max-w-2xl mx-auto px-4 py-4 pb-24">
        <Outlet />
      </main>
      <nav className="fixed bottom-0 inset-x-0 bg-gray-900/95 backdrop-blur border-t border-white/10 z-40">
        <div className="max-w-2xl mx-auto flex">
          {[{ to: '/sales', icon: Map, label: 'Plan' }, { to: '/sales/stats', icon: BarChart3, label: 'Scoreboard' }].map(t => (
            <NavLink key={t.to} to={t.to} end className={({ isActive }) => `flex-1 flex flex-col items-center py-2.5 text-xs font-semibold ${isActive ? 'text-brand-400' : 'text-gray-500 hover:text-gray-300'}`}>
              <t.icon className="h-5 w-5 mb-0.5" /> {t.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
